import { unifiedDetermineArticleHeadingCount } from '@s1/core/utilities';
import paginated_fluid from '../../_paginated2';

const paginated = () => {
  paginated_fluid();
  unifiedDetermineArticleHeadingCount();
};

window.addEventListener('DOMContentLoaded', () => {
  paginated();
});
